export const homeText = {
  JP: {
    description:
      '宮古島の絶景を舞台に、\n一生忘れられない特別な体験をお届けします',
    all: '全ての方',
    general: '一般の方',
    influencer: 'インフルエンサーの方',
    creator: 'クリエイターの方',
  },

  EN: {
    description:
      'A more refined ocean experience in Miyakojima,\ncaptured in photos and videos.',
    all: 'All',
    general: 'General Guests',
    influencer: 'Inluencers',
    creator: 'Creators',
  },

  中文: {
    description:
      '在宫古岛，用照片与影片留下\n稍微成熟一点的海岛体验。',
    all: '所有游客',
    general: '普通游客',
    influencer: '网红',
    creator: '内容创作者',
  },

  한국어: {
    description:
      '미야코지마에서 사진과 영상으로 남기는\n조금 더 특별한 바다 체험.',
    all: '모든 고객',
    general: '일반 고객',
    influencer: '인플루언서',
    creator: '크리에이터',
  }
};
